<nav mat-tab-nav-bar backgroundColor="primary" [tabPanel]="panel">
    <a mat-tab-link routerLink="/addresses/contacts" [active]="(url$ | async) == '/addresses/contacts'" i18n>Contacts</a>
    <a mat-tab-link routerLink="/addresses/books" [active]="(url$ | async) == '/addresses/books'" i18n>Address Books</a>
</nav>
<mat-tab-nav-panel #panel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>

